const LikeBorder = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}>
        <use xlinkHref="#likecounter" />
    </svg>
);

export default LikeBorder;
